import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import {
  RequestShiftDownloadExcelDto,
  RequestShiftSendExcelDto,
  RequestShiftSendPdfDto
} from "../../shared/nestjs/gd-only/dto/shiftschedule-report.dto";
import { ShiftReportApi } from "../../shared/nestjs/gd-only/services/shiftschedule-report.api";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth } from "../../shared/sdk";
import { ViewShiftscheduleReportApi } from "../../shared/sdk/services/custom";
@Injectable()
export class ShiftReportBloc {
  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private viewShiftReportApi: ViewShiftscheduleReportApi,
    private nestApiProvider: NestApiProvider,
    private fileDownloaderProvider: FileDownloaderProvider,
    private platform: Platform,
    private shiftReportApi: ShiftReportApi,
    private analyticsProvider: AnalyticsProvider
  ) {

  }

  downloadExcel(data: RequestShiftDownloadExcelDto): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
    return this.shiftReportApi.downloadExcel(data)
  }

  generateExcel(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadExcelBlob(data, 'Shift Report')
    } else {
      saveAs(data, 'Shift Report.xlsx')
    }
  }

  downloadPdf(data): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
    return this.shiftReportApi.downloadPdf(data)
  }

  generatePdf(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, 'Shift Report')
    } else {
      saveAs(data, 'Shift Report.pdf')
    }
  }

  sendExcel(data):Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);

        if (isGoPathNewExist) {
          let dataNest : RequestShiftSendExcelDto = new RequestShiftSendExcelDto();
          dataNest.allEmp = data.allEmp;
          dataNest.listEmp = data.listEmp;
          dataNest.emailUser = data.emailUser;
          dataNest.fullName = data.fullName;
          dataNest.startDate = data.startDate;
          dataNest.endDate = data.endDate
          return this.shiftReportApi.reportSendEmailExcel(dataNest)
        }else{
          data.sendEmail = true;
          return this.viewShiftReportApi.download(data)
        }
      })
  }

  sendPdf(data):Observable<any>{
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);

        if (isGoPathNewExist) {
          let dataNest : RequestShiftSendPdfDto = new RequestShiftSendPdfDto();
          dataNest.allEmp = data.allEmp;
          dataNest.listEmp = data.listEmp;
          dataNest.emailUser = data.emailUser;
          dataNest.fullName = data.fullName;
          dataNest.startDate = data.startDate;
          dataNest.endDate = data.endDate;
          return this.shiftReportApi.reportSendEmailPdf(dataNest)
        }else {
          data.sendEmail = true;
         return this.viewShiftReportApi.pdfmake(data)
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/bloc/report/shift-report.bloc.ts